(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ws_stock-alert"] && !Shopify.designMode) return;
  try {
    function wsGetRandomNumber(min, max) {
    var minNum = parseInt(min, 10);
    var maxNum = parseInt(max, 10);

    if (isNaN(minNum)) minNum = 1;
    if (isNaN(maxNum)) maxNum = minNum;
    if (maxNum < minNum) maxNum = minNum;

    return Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum;
  }

  function wsUpdateAllStockCountdowns() {
    var countdownElements = document.querySelectorAll('[data-stock-countdown]');

    countdownElements.forEach(function (elem) {
      var min = elem.getAttribute('data-min');
      var max = elem.getAttribute('data-max');
      var randomNumber = wsGetRandomNumber(min, max);
      elem.textContent = randomNumber;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wsUpdateAllStockCountdowns);
  } else {
    wsUpdateAllStockCountdowns();
  }

  document.addEventListener('variant:change', function () {
    wsUpdateAllStockCountdowns();
  });
  } catch(e) { console.error(e); }
})();

})();
